import React, { useEffect, useState } from "react";
import Participant from "./Participant";
import "./room.css";

const Room = ({ roomName, room }) => {
  const [participants, setParticipants] = useState([]);

  useEffect(() => {
    const participantConnected = (participant) => {
      setParticipants((prevParticipants) => [...prevParticipants, participant]);
    };

    const participantDisconnected = (participant) => {
      setParticipants((prevParticipants) =>
        prevParticipants.filter((p) => p !== participant)
      );
    };

    room.on("participantConnected", participantConnected);
    room.on("participantDisconnected", participantDisconnected);
    room.participants.forEach(participantConnected);
    return () => {
      room.off("participantConnected", participantConnected);
      room.off("participantDisconnected", participantDisconnected);
    };
  }, [room]);

  const remoteParticipants = participants.map((participant) => (
    <Participant key={participant.sid} participant={participant} />
  ));

  return (
    <div className="room" >
      {/* <button onClick={handleLogout}>Log out</button> */}
      {/* <h2>Room: {roomName}</h2> */}
      <div className ="participant">
        {room ? (
          <Participant
            key={room.localParticipant.sid}
            participant={room.localParticipant}
          />
        ) : (
          ""
        )}
      </div>
      {/* <h3>Remote Participants</h3> */}
      <div className="remote-participants">{remoteParticipants}</div>
    </div>
  );
};

export default Room;
